import { render } from "./GroupLearningEditorView.vue?vue&type=template&id=650f7ba7"
import script from "./GroupLearningEditorView.vue?vue&type=script&lang=js"
export * from "./GroupLearningEditorView.vue?vue&type=script&lang=js"

import "./GroupLearningEditorView.vue?vue&type=style&index=0&id=650f7ba7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__